var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNginx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.4,
    height: 82.175,
    viewBox: "0 0 19.156 21.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.578.026c-.238 0-.45.053-.662.186L.661 4.974A1.334 1.334 0 0 0 0 6.112v9.551c0 .238.053.45.185.662L9.578 10.9V.026z",
    fill: "#00ab4e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.185 16.298c.106.186.265.37.476.477l8.255 4.789c.397.238.9.238 1.297 0l8.281-4.79c.212-.105.37-.29.477-.476l-9.393-5.424s-6.086 3.52-9.393 5.424z",
    fill: "#00853e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.97 16.298c.106-.185.186-.423.186-.661V6.085c0-.476-.238-.9-.662-1.137L10.24.185C10.028.08 9.816 0 9.578 0v10.848c0 .026 6.085 3.545 9.393 5.45z",
    fill: "#004c2c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.747 15.002c.37.45.953.661 1.482.661.715 0 1.244-.476 1.244-1.058V7.144c0-.582-.477-1.059-1.059-1.059h-.026c-.609 0-1.085.477-1.085 1.085v5.318c0 .027-.026.027-.053.027L7.408 6.747c-.37-.45-.952-.662-1.481-.662-.715 0-1.244.477-1.244 1.059v7.461c0 .582.476 1.058 1.058 1.058h.027c.608 0 1.085-.476 1.085-1.084V9.26c0-.026.026-.026.053-.026z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNginx);
export default __webpack_public_path__ + "static/media/nginx.839c4f994e9a95e0e9cdbc0ba34dde01.svg";
export { ForwardRef as ReactComponent };